import { gql } from "@apollo/client";

export default gql`
  query listAiMessages($data: ListInfiniteParams!){
    listAiMessages(data: $data){
        success
        data{
            docs{
                _id
                customerId
                questionId
                answerId
                question
                answer
                answers{
                    messageType
                    content
                    messageId
                    productCards{
                        productId
                        title
                        thumbnailUrl
                        optionsSummary
                        productUrl
                        price{
                            amount
                            currency
                        }
                    }
                }
                questionMedia{
                    name
                    type
                    path
                }
                questionContext{
                    productName
                    productLink
                    productImageUrl
                    postUrl
                    postImageUrl
                }
                status
                channelType
                conversationId
                error
                isTest
                kind
                outcome
                durationMs
                usage{
                    inputToken
                    cachedInputToken
                    outputToken
                    amount
                    llmCalls
                }
                failedStepCount
                createdAt
                updatedAt
            }
            hasNextPage
            totalDocs
            offset
            limit
        }
        code
        message
    }
}
`
